import { useContext } from 'react';
import { MobXProviderContext } from 'mobx-react';

const useTemplateEditorStore = () => {
  return useContext(MobXProviderContext).templateEditorStore;
};

export default useTemplateEditorStore;
